<script setup lang="ts">
import { clientFunctionCategories, type ClientFunctionCategory } from "./functionCategories";

export type ClientDetailSection = ClientFunctionCategory;

defineProps<{ active: ClientDetailSection }>();
const emit = defineEmits<{ select: [section: ClientDetailSection] }>();

const sections = clientFunctionCategories.map(({ id, title }) => ({ id, label: title }));

function navigateTabs(event: KeyboardEvent) {
  const tabs = Array.from((event.currentTarget as HTMLElement).querySelectorAll<HTMLButtonElement>('[role="tab"]'));
  const index = tabs.indexOf(event.target as HTMLButtonElement);
  const next = event.key === "ArrowRight" ? (index + 1) % tabs.length
    : event.key === "ArrowLeft" ? (index + tabs.length - 1) % tabs.length
    : event.key === "Home" ? 0 : event.key === "End" ? tabs.length - 1 : -1;
  if (next < 0) return;
  event.preventDefault();
  emit("select", sections[next]!.id);
  tabs[next]?.focus();
}
</script>

<template>
  <nav aria-label="Điều hướng máy trạm" class="border-base-200 mb-4 border-b">
    <div role="tablist" class="tabs tabs-border flex-nowrap overflow-x-auto" @keydown="navigateTabs">
      <button
        v-for="section in sections"
        :key="section.id"
        :id="`client-section-${section.id}`"
        aria-controls="client-detail-content"
        :tabindex="active === section.id ? 0 : -1"
        type="button"
        role="tab"
        :aria-selected="active === section.id"
        :class="['tab whitespace-nowrap', active === section.id && 'tab-active text-primary']"
        @click="emit('select', section.id)"
      >
        {{ section.label }}
      </button>
    </div>
  </nav>
</template>
